export default "__VITE_ASSET__NdtcA5kh__"